<div style="font-size: larger" [innerHTML]="reportHTML"></div>
<div *ngIf="component_mawp.strD_iclass == 6" class="center-content">
  <img [src]="crackLikeImageUrl" alt="report-image" />
</div>
<div *ngIf="component_mawp.strD_iclass == 8" class="center-content">
  <img [src]="dentGougeImageUrl" alt="report-image" />
</div>
